export const featureDashboardData =
  import.meta.env.VITE_FEATURE_DASHBOARD_DATA === "true";

export const featureRoundManagementPage =
  import.meta.env.VITE_FEATURE_ROUND_MANAGEMENT_PAGE === "true";

export const featureFreeBid = import.meta.env.VITE_FREE_BID_FEATURE === "true";

export const featureWallet = import.meta.env.VITE_WALLET_FEATURE === "true";
